import tier4CardWidget from './tier4CardWidget';
import tier4SeoBlock from './tier4SeoBlock';
import tier4Slideshow from './tier4Slideshow';
import managedBackground from '../../utils/managedBackground';

export default async function renderTier4Widgets() {
  const [hasSeo, hasCardWidget, hasSlideshow] = await Promise.all([
    tier4SeoBlock(),
    tier4CardWidget(),
    tier4Slideshow(),
  ]);

  if (hasCardWidget || hasSeo || hasSlideshow) {
    managedBackground({
      widgetConfigName: 'backgroundTier4',
      widgetConfigOpts: backgroundTier4Opts,
      widgetConfigDestination: '.tier-4-container',
      widgetConfigContainerClass: 'managed-bg',
    });
  }
}
